import { StateCreator } from 'zustand';
import { ToolNames } from './ToolNames';
import { IAppStore } from '../IAppStore';
import ActiveToolSlice, { ActiveToolSliceProps } from './ActiveToolSlice';

export const defaultActiveToolProps: ActiveToolSliceProps = {
  activeTool: ToolNames.identify,
  activeView: '',
  enabledIdentify: true,
};

const createActiveToolSlice: StateCreator<IAppStore, [], [], ActiveToolSlice> = (
  set,
) => ({
  ...defaultActiveToolProps,
  setActiveTool: (tool: ToolNames, view?: string) =>
    set({ activeTool: tool, activeView: view }),
  setActiveView: (key: string) => set({ activeView: key }),
  toggleIdentify: () => set((state) => ({ enabledIdentify: !state.enabledIdentify })),
});

export default createActiveToolSlice;
